// import React, { useEffect, useRef, useState, useMemo } from "react";
// import {
//   Box,
//   Button,
//   Container,
//   Typography,
//   Avatar,
//   TextField,
//   Paper,
//   IconButton,
//   Stack,
//   Divider,
// } from "@mui/material";
// import ThumbUpIcon from "@mui/icons-material/ThumbUp";
// import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
// import { useLocation, useSearchParams } from "react-router-dom";
// import { useAppSelector } from "../../store/hooks";
// import axios from "axios";
// import api from "../../api/endpoints";
// import Player from "@vimeo/player";

// type Comment = {
//   comment_id?: number;
//   user_id: number;
//   first_name?: string;
//   vid_comment?: string;
//   updated_on?: string;
// };

// // --- Vimeo Player ---
// const extractVimeoId = (input: string): string => {
//   // Accept raw ID or full URL
//   if (/^\d+$/.test(input)) return input;
//   const match = input.match(/vimeo\.com\/(?:video\/)?(\d+)/);
//   return match ? match[1] : "";
// };

// const VimeoPlayer: React.FC<{ videoUrl: string }> = ({ videoUrl }) => {
//   const [playTime, setPlayTime] = useState<number>(0);
//   const [isPlaying, setIsPlaying] = useState<boolean>(false);
//   const [ready, setReady] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);
//   const playerRef = useRef<Player | null>(null);
//   const containerRef = useRef<HTMLDivElement | null>(null);

//   const videoId = extractVimeoId(videoUrl);

//   useEffect(() => {
//     if (!videoId) {
//       setError("Invalid Vimeo URL/ID");
//       return;
//     }
//     setError(null);

//     if (!containerRef.current) return;
//     const player = new Player(containerRef.current, {
//       id: Number(videoId),
//       autopause: true,
//       // optional: controls are built-in
//     });

//     playerRef.current = player;

//     player
//       .ready()
//       .then(() => {
//         setReady(true);
//       })
//       .catch((e: any) => {
//         console.error("Vimeo player ready error:", e);
//         setError("Failed to initialize Vimeo player.");
//       });

//     // timeupdate gives current playback time
//     const onTimeUpdate = (data: { seconds: number }) => {
//       setPlayTime(Math.floor(data.seconds));
//     };
//     const onPlay = () => setIsPlaying(true);
//     const onPause = () => setIsPlaying(false);
//     const onEnded = () => setIsPlaying(false);

//     player.on("timeupdate", onTimeUpdate);
//     player.on("play", onPlay);
//     player.on("pause", onPause);
//     player.on("ended", onEnded);

//     return () => {
//       player.off("timeupdate", onTimeUpdate);
//       player.off("play", onPlay);
//       player.off("pause", onPause);
//       player.off("ended", onEnded);
//       player.unload().catch(() => {});
//       playerRef.current = null;
//     };
//   }, [videoId]);

//   const play = async () => {
//     if (!playerRef.current) return;
//     try {
//       await playerRef.current.play();
//     } catch (e) {
//       console.error("Play error:", e);
//       setError("Unable to play video.");
//     }
//   };

//   const pause = async () => {
//     if (!playerRef.current) return;
//     try {
//       await playerRef.current.pause();
//     } catch (e) {
//       console.error("Pause error:", e);
//       setError("Unable to pause video.");
//     }
//   };

//   const restart = async () => {
//     if (!playerRef.current) return;
//     try {
//       await playerRef.current.setCurrentTime(0);
//       await playerRef.current.play();
//     } catch (e) {
//       console.error("Restart error:", e);
//       setError("Unable to restart video.");
//     }
//   };

//   const formatTime = (s: number) => {
//     if (isNaN(s) || s < 0) return "00:00";
//     return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(
//       s % 60
//     ).padStart(2, "0")}`;
//   };

//   if (error) {
//     return (
//       <Box>
//         <Box
//           sx={{
//             aspectRatio: "16/9",
//             width: "100%",
//             borderRadius: 2,
//             overflow: "hidden",
//             boxShadow: 3,
//             bgcolor: "#000",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <Typography color="white">
//             {error} <br />
//             <code>{videoUrl}</code>
//           </Typography>
//         </Box>
//       </Box>
//     );
//   }

//   return (
//     <Box>
//       <Box
//         sx={{
//           position: "relative",
//           aspectRatio: "16/9",
//           width: "100%",
//           borderRadius: 2,
//           overflow: "hidden",
//           boxShadow: 3,
//           bgcolor: "#000",
//         }}
//       >
//         <div
//           ref={(el) => {
//             containerRef.current = el;
//           }}
//           style={{ width: "100%", height: "100%" }}
//         />
//       </Box>

//       <Box mt={2} textAlign="center">
//         <Typography variant="subtitle1" gutterBottom>
//           You have watched: <strong>{formatTime(playTime)}</strong>
//         </Typography>
//         <Stack direction="row" spacing={2} justifyContent="center">
//           <Button
//             onClick={play}
//             variant="contained"
//             disabled={!ready || isPlaying}
//             sx={{ minWidth: 100 }}
//           >
//             ▶️ Play
//           </Button>
//           <Button
//             onClick={pause}
//             variant="outlined"
//             disabled={!ready || !isPlaying}
//             sx={{ minWidth: 100 }}
//           >
//             ⏸️ Pause
//           </Button>
//           <Button
//             onClick={restart}
//             variant="text"
//             disabled={!ready}
//             sx={{ minWidth: 100 }}
//           >
//             🔁 Restart
//           </Button>
//         </Stack>
//         {!ready && (
//           <Typography variant="caption" color="text.secondary" mt={1}>
//             Initializing player...
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// // --- Like Button ---
// interface LikeButtonProps {
//   likes: number;
//   isInitiallyLiked?: boolean;
//   onToggle: (newLiked: boolean) => void;
// }
// const LikeButton: React.FC<LikeButtonProps> = ({
//   likes,
//   isInitiallyLiked = false,
//   onToggle,
// }) => {
//   const [count, setCount] = useState(likes);
//   const [isLiked, setIsLiked] = useState(isInitiallyLiked);
//   const togglingRef = useRef(false);

//   const toggleLike = async () => {
//     if (togglingRef.current) return;
//     togglingRef.current = true;
//     const nextLiked = !isLiked;
//     setIsLiked(nextLiked);
//     setCount((c) => (nextLiked ? c + 1 : Math.max(0, c - 1)));
//     try {
//       await onToggle(nextLiked);
//     } catch (e) {
//       // rollback
//       setIsLiked(isLiked);
//       setCount((c) => (isLiked ? c + 1 : Math.max(0, c - 1)));
//     } finally {
//       togglingRef.current = false;
//     }
//   };

//   return (
//     <Stack direction="row" alignItems="center" spacing={2} mt={3}>
//       <IconButton onClick={toggleLike} color="primary" aria-label="like">
//         {isLiked ? <ThumbUpIcon /> : <ThumbUpOutlinedIcon />}
//       </IconButton>
//       <Typography variant="h6">{count.toLocaleString()} likes</Typography>
//     </Stack>
//   );
// };

// // --- Comment Avatar ---
// const CommentAvatar: React.FC<{ first_name?: string; user_id: number }> = ({
//   first_name,
//   user_id,
// }) => {
//   const bg = useMemo(() => {
//     const hue = Math.floor(Math.random() * 360);
//     return `hsl(${hue}, 60%, 70%)`;
//   }, []);

//   return (
//     <Avatar sx={{ bgcolor: bg, color: "#000" }}>
//       {first_name ? first_name[0].toUpperCase() : "G"}
//     </Avatar>
//   );
// };

// // --- Comment Form ---
// const CommentForm: React.FC<{ onSubmit: (c: Comment) => void }> = ({
//   onSubmit,
// }) => {
//   const [text, setText] = useState("");
//   const customerData = useAppSelector(
//     (state) => state.customer.personalDetails
//   );
//   const usermaster_id = sessionStorage.getItem("user_id");

//   const handleSubmit = (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!text.trim()) return;
//     onSubmit({
//       user_id: Number(sessionStorage.getItem("user_id")) || 0,
//       first_name: customerData?.firstname ?? "GuestUser",
//       vid_comment: text.trim(),
//     });
//     setText("");
//   };

//   return (
//     <Box component="form" onSubmit={handleSubmit} mt={3}>
//       <Stack direction="row" spacing={2}>
//         <CommentAvatar
//           first_name={customerData?.firstname}
//           user_id={Number(usermaster_id)}
//         />
//         <TextField
//           fullWidth
//           value={text}
//           onChange={(e) => setText(e.target.value)}
//           label="Add a comment"
//           multiline
//           rows={2}
//         />
//       </Stack>
//       <Box mt={2} textAlign="right">
//         <Button type="submit" variant="contained" disabled={!text.trim()}>
//           Comment
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// // --- Comment List ---
// const CommentList: React.FC<{ comments: Comment[] }> = ({ comments }) => (
//   <Box mt={3}>
//     {comments.map((c, i) => (
//       <Box key={i} mb={2}>
//         <Stack direction="row" spacing={2}>
//           <CommentAvatar first_name={c.first_name} user_id={c.user_id} />
//           <Box>
//             <Typography fontWeight="bold">
//               {c.first_name || "GuestUser"}
//             </Typography>
//             <Typography>{c.vid_comment}</Typography>
//             {c.updated_on && (
//               <Typography variant="caption" color="text.secondary">
//                 {new Date(c.updated_on).toLocaleString()}
//               </Typography>
//             )}
//           </Box>
//         </Stack>
//         {i !== comments.length - 1 && <Divider sx={{ my: 2 }} />}
//       </Box>
//     ))}
//   </Box>
// );

// // --- Comments Section ---
// interface CommentsSectionProps {
//   comments: Comment[];
//   onAddComment: (c: Comment) => void;
// }
// const CommentsSection: React.FC<CommentsSectionProps> = ({
//   comments,
//   onAddComment,
// }) => {
//   const COMMENT_ITEM_HEIGHT = 72;
//   const VISIBLE_COUNT = 5;

//   return (
//     <Paper elevation={3} sx={{ p: 3 }}>
//       <Typography variant="h6" mb={2}>
//         {comments.length} Comments
//       </Typography>
//       <CommentForm onSubmit={onAddComment} />
//       <Box
//         sx={{
//           maxHeight: COMMENT_ITEM_HEIGHT * VISIBLE_COUNT,
//           overflowY: "auto",
//           position: "relative",
//           marginTop: 1,
//         }}
//       >
//         <CommentList comments={comments} />
//       </Box>
//     </Paper>
//   );
// };

// // --- Main App ---
// const VideoApp: React.FC = () => {
//   const linkToDisplay = useAppSelector(
//     (state) => state.searchReducer.linkToDisplay
//   );

//   const customerDetails = useAppSelector(
//     (state) => state.customer.customerDetails
//   );

//   const [searchParams] = useSearchParams();
//   const location = useLocation();
//   const { title, article_id } = location.state as {
//     article_id: string;
//     title: string;
//   };

//   const articleId = searchParams.get("articleId") ?? article_id;
//   const customer_id = sessionStorage.getItem("informaticscustomer_id");
//   const usermaster_id = sessionStorage.getItem("user_id");
//   const consortia_id = customerDetails?.consortiamaster_id ?? null;
//   const [comments, setComments] = useState<Comment[]>([]);
//   const [likeCount, setLikeCount] = useState<number>(0);
//   const [isLiked, setIsLiked] = useState<boolean>(false);

//   const buttonLink = useMemo(() => {
//     if (!articleId || !Array.isArray(linkToDisplay)) return "";
//     const found = linkToDisplay.find((obj) => obj?.article_id === articleId);
//     return found?.links?.[0] || "";
//   }, [articleId, linkToDisplay]);

//   const videoUrlToUse = buttonLink || "https://vimeo.com/759560753"; // fallback

//   const normalizeComments = (raw: any[]): Comment[] =>
//     raw.map((c) => ({
//       comment_id: c.comment_id,
//       user_id: Number(c.user_id) || 0,
//       first_name: c.first_name || "GuestUser",
//       vid_comment: c.vid_comment || "",
//       updated_on: c.updated_on,
//     }));

//   useEffect(() => {
//     if (!articleId) return;
//     fetchLikeInfo();
//     fetchInitialComments();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [articleId, customer_id, usermaster_id, consortia_id]);

//   async function postLikeUsage(liked: boolean) {
//     if (!articleId) return;
//     const apiFormData = {
//       data: [
//         {
//           customer_id: customer_id,
//           usermaster_id: usermaster_id,
//           consortia_id: consortia_id,
//           article_id: articleId,
//           is_liked: liked,
//         },
//       ],
//     };
//     const formData = new FormData();
//     formData.append("detailed_json", JSON.stringify(apiFormData));
//     try {
//       await axios.post(
//         api.baseApi + `/api/insert_video_likes_usage/insert_video_likes_usage`,
//         formData
//       );
//     } catch (err) {
//       console.log("postLikeUsage error:", err);
//       throw err;
//     }
//   }

//   async function fetchLikeInfo() {
//     if (!articleId) return;
//     try {
//       const response = await axios.get(
//         api.baseApi +
//           `/api/get_article_like_by_id/get_article_like_by_id?article_id=${articleId}`
//       );
//       const data = response.data?.data?.[0];
//       if (data) {
//         setLikeCount(Number(data.liked_count ?? likeCount));
//         if (typeof data.is_liked === "boolean") setIsLiked(data.is_liked);
//       }
//     } catch (err) {
//       console.log("fetchLikeInfo error:", err);
//     }
//   }

//   async function fetchInitialComments() {
//     if (!articleId) return;
//     try {
//       const response = await axios.get(
//         api.baseApi +
//           `/api/get_article_comments_by_id/get_article_comments_by_id?article_id=${articleId}`
//       );
//       const fetched = response.data?.data?.[0];
//       if (Array.isArray(fetched) && fetched.length > 0) {
//         setComments(normalizeComments(fetched));
//       } else {
//         setComments([]);
//       }
//     } catch (err) {
//       console.log("fetchInitialComments error:", err);
//     }
//   }

//   async function postCommentUsage(comment: Comment) {
//     if (!articleId) return;
//     const apiFormData = {
//       data: [
//         {
//           customer_id: customer_id,
//           consortia_id: consortia_id,
//           usermaster_id: usermaster_id,
//           article_id: articleId,
//           status: true,
//           comments: comment.vid_comment ?? "",
//           user_id: comment.user_id,
//         },
//       ],
//     };
//     const formData = new FormData();
//     formData.append("detailed_json", JSON.stringify(apiFormData));
//     try {
//       await axios.post(
//         api.baseApi +
//           `/api/insert_video_coment_usage/insert_video_coment_usage?`,
//         formData
//       );
//     } catch (err) {
//       console.log("postCommentUsage error:", err);
//     }
//   }

//   const handleAddComment = async (newComment: Comment) => {
//     setComments((prev) => [newComment, ...prev]);
//     try {
//       await postCommentUsage(newComment);
//     } catch (e) {
//       console.log("handleAddComment error:", e);
//     }
//   };

//   const handleLikeToggle = async (nextLiked: boolean) => {
//     await postLikeUsage(nextLiked);
//     setIsLiked(nextLiked);
//     setLikeCount((prev) => (nextLiked ? prev + 1 : Math.max(0, prev - 1)));
//   };

//   const videoData = {
//     title: "Video Title Placeholder",
//     description: "Video description goes here.",
//   };

//   return (
//     <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", py: 5 }}>
//       <Container maxWidth="lg">
//         <Stack spacing={4} direction={{ xs: "column", lg: "row" }}>
//           <Box flex={2}>
//             <VimeoPlayer videoUrl={videoUrlToUse} />
//             <Typography variant="h4" mt={4}>
//               {title || videoData.title}
//             </Typography>
//             <Typography mt={1} whiteSpace="pre-line">
//               {videoData.description}
//             </Typography>
//             <LikeButton
//               likes={likeCount}
//               isInitiallyLiked={isLiked}
//               onToggle={handleLikeToggle}
//             />
//           </Box>

//           <Box flex={1}>
//             <CommentsSection
//               comments={comments ?? []}
//               onAddComment={handleAddComment}
//             />
//           </Box>
//         </Stack>
//       </Container>
//     </Box>
//   );
// };

// export default VideoApp;

// =========================================================================================

// import React, { useEffect, useRef, useState } from "react";
// import { Box, Button, Typography, Stack } from "@mui/material";

// // --- Vimeo SDK loader (no @vimeo/player import required) ---
// declare global {
//   interface Window {
//     Vimeo: any;
//   }
// }

// const loadVimeoSDK = (): Promise<void> => {
//   return new Promise((resolve, reject) => {
//     if ((window as any).Vimeo && (window as any).Vimeo.Player) {
//       return resolve();
//     }
//     const script = document.createElement("script");
//     script.src = "https://player.vimeo.com/api/player.js";
//     script.async = true;
//     script.onload = () => {
//       if ((window as any).Vimeo && (window as any).Vimeo.Player) {
//         resolve();
//       } else {
//         reject(new Error("Vimeo SDK loaded but Player not available"));
//       }
//     };
//     script.onerror = () => reject(new Error("Failed to load Vimeo SDK"));
//     document.body.appendChild(script);
//   });
// };

// // --- VimeoPlayer component with hardcoded URL ---
// const VideoApp: React.FC = () => {
//   const HARDCODED_VIMEO_URL = "https://player.vimeo.com/video/759560753"; // <--- replace this with the URL you provide
//   const [playTime, setPlayTime] = useState<number>(0);
//   const [isPlaying, setIsPlaying] = useState<boolean>(false);
//   const [ready, setReady] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);
//   const playerRef = useRef<any>(null);
//   const containerRef = useRef<HTMLDivElement | null>(null);

//   useEffect(() => {
//     setError(null);

//     loadVimeoSDK()
//       .then(() => {
//         if (!containerRef.current) return;
//         // @ts-ignore
//         const player = new window.Vimeo.Player(containerRef.current, {
//           url: HARDCODED_VIMEO_URL,
//           autopause: true,
//         });
//         playerRef.current = player;

//         player
//           .ready()
//           .then(() => setReady(true))
//           .catch((e: any) => {
//             console.error("Vimeo ready error", e);
//             setError("Failed to initialize Vimeo player.");
//           });

//         player.on("timeupdate", (data: { seconds: number }) => {
//           setPlayTime(Math.floor(data.seconds));
//         });
//         player.on("play", () => setIsPlaying(true));
//         player.on("pause", () => setIsPlaying(false));
//         player.on("ended", () => setIsPlaying(false));
//       })
//       .catch((e) => {
//         console.error("SDK load failed", e);
//         setError("Failed to load Vimeo SDK.");
//       });

//     return () => {
//       if (playerRef.current) {
//         playerRef.current.unload?.().catch(() => {});
//         playerRef.current = null;
//       }
//     };
//   }, [HARDCODED_VIMEO_URL]);

//   const play = () => playerRef.current?.play?.();
//   const pause = () => playerRef.current?.pause?.();
//   const restart = async () => {
//     if (!playerRef.current) return;
//     try {
//       await playerRef.current.setCurrentTime(0);
//       await playerRef.current.play();
//     } catch (e) {
//       console.error("Restart error:", e);
//       setError("Unable to restart video.");
//     }
//   };

//   const formatTime = (s: number) => {
//     if (isNaN(s) || s < 0) return "00:00";
//     return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(
//       s % 60
//     ).padStart(2, "0")}`;
//   };

//   if (error) {
//     return (
//       <Box>
//         <Box
//           sx={{
//             aspectRatio: "16/9",
//             width: "100%",
//             borderRadius: 2,
//             overflow: "hidden",
//             boxShadow: 3,
//             bgcolor: "#000",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <Typography color="white">
//             {error} <br />
//             <code>{HARDCODED_VIMEO_URL}</code>
//           </Typography>
//         </Box>
//       </Box>
//     );
//   }

//   return (
//     <Box>
//       <Box
//         sx={{
//           position: "relative",
//           aspectRatio: "16/9",
//           width: "100%",
//           borderRadius: 2,
//           overflow: "hidden",
//           boxShadow: 3,
//           bgcolor: "#000",
//         }}
//       >
//         <div
//           ref={(el) => {
//             containerRef.current = el;
//           }}
//           style={{ width: "100%", height: "100%" }}
//         />
//       </Box>

//       <Box mt={2} textAlign="center">
//         <Typography variant="subtitle1" gutterBottom>
//           You have watched: <strong>{formatTime(playTime)}</strong>
//         </Typography>
//         <Stack direction="row" spacing={2} justifyContent="center">
//           <Button
//             onClick={play}
//             variant="contained"
//             disabled={!ready || isPlaying}
//           >
//             ▶️ Play
//           </Button>
//           <Button
//             onClick={pause}
//             variant="outlined"
//             disabled={!ready || !isPlaying}
//           >
//             ⏸️ Pause
//           </Button>
//           <Button onClick={restart} variant="text" disabled={!ready}>
//             🔁 Restart
//           </Button>
//         </Stack>
//         {!ready && (
//           <Typography variant="caption" color="text.secondary" mt={1}>
//             Initializing player...
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default VideoApp;

// =============================================================================

// import React, { useEffect, useRef, useState, useMemo } from "react";
// import {
//   Box,
//   Button,
//   Container,
//   Typography,
//   Avatar,
//   TextField,
//   Paper,
//   IconButton,
//   Stack,
//   Divider,
// } from "@mui/material";
// import ThumbUpIcon from "@mui/icons-material/ThumbUp";
// import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
// import { useLocation, useSearchParams } from "react-router-dom";
// import { useAppSelector } from "../../store/hooks";
// import axios from "axios";
// import api from "../../api/endpoints";

// // --- Types ---
// type Comment = {
//   comment_id?: number;
//   user_id: number;
//   first_name?: string;
//   vid_comment?: string;
//   updated_on?: string;
// };

// // --- Vimeo SDK loader (no external package required) ---
// declare global {
//   interface Window {
//     Vimeo: any;
//   }
// }
// const loadVimeoSDK = (): Promise<void> => {
//   return new Promise((resolve, reject) => {
//     if ((window as any).Vimeo && (window as any).Vimeo.Player) {
//       return resolve();
//     }
//     const script = document.createElement("script");
//     script.src = "https://player.vimeo.com/api/player.js";
//     script.async = true;
//     script.onload = () => {
//       if ((window as any).Vimeo && (window as any).Vimeo.Player) {
//         resolve();
//       } else {
//         reject(new Error("Vimeo SDK loaded but Player not available"));
//       }
//     };
//     script.onerror = () => reject(new Error("Failed to load Vimeo SDK"));
//     document.body.appendChild(script);
//   });
// };

// // --- VimeoPlayer with hardcoded full URL ---
// const VimeoPlayer: React.FC = () => {
//   const HARDCODED_VIMEO_URL = "https://vimeo.com/759560753"; // <--- replace with the URL you want
//   const [playTime, setPlayTime] = useState<number>(0);
//   const [isPlaying, setIsPlaying] = useState<boolean>(false);
//   const [ready, setReady] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);
//   const playerRef = useRef<any>(null);
//   const containerRef = useRef<HTMLDivElement | null>(null);

//   useEffect(() => {
//     setError(null);
//     loadVimeoSDK()
//       .then(() => {
//         if (!containerRef.current) return;
//         // @ts-ignore
//         const player = new window.Vimeo.Player(containerRef.current, {
//           url: HARDCODED_VIMEO_URL,
//           autopause: true,
//         });
//         playerRef.current = player;

//         player
//           .ready()
//           .then(() => setReady(true))
//           .catch((e: any) => {
//             console.error("Vimeo ready error", e);
//             setError("Failed to initialize Vimeo player.");
//           });

//         player.on("timeupdate", (data: { seconds: number }) => {
//           setPlayTime(Math.floor(data.seconds));
//         });
//         player.on("play", () => setIsPlaying(true));
//         player.on("pause", () => setIsPlaying(false));
//         player.on("ended", () => setIsPlaying(false));
//       })
//       .catch((e) => {
//         console.error("SDK load failed", e);
//         setError("Failed to load Vimeo SDK.");
//       });

//     return () => {
//       if (playerRef.current) {
//         playerRef.current.unload?.().catch(() => {});
//         playerRef.current = null;
//       }
//     };
//   }, [HARDCODED_VIMEO_URL]);

//   const play = () => playerRef.current?.play?.();
//   const pause = () => playerRef.current?.pause?.();
//   const restart = async () => {
//     if (!playerRef.current) return;
//     try {
//       await playerRef.current.setCurrentTime(0);
//       await playerRef.current.play();
//     } catch (e) {
//       console.error("Restart error:", e);
//       setError("Unable to restart video.");
//     }
//   };

//   const formatTime = (s: number) => {
//     if (isNaN(s) || s < 0) return "00:00";
//     return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(
//       s % 60
//     ).padStart(2, "0")}`;
//   };

//   if (error) {
//     return (
//       <Box>
//         <Box
//           sx={{
//             aspectRatio: "16/9",
//             width: "100%",
//             borderRadius: 2,
//             overflow: "hidden",
//             boxShadow: 3,
//             bgcolor: "#000",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <Typography color="white">
//             {error} <br />
//             <code>{HARDCODED_VIMEO_URL}</code>
//           </Typography>
//         </Box>
//       </Box>
//     );
//   }

//   return (
//     <Box>
//       <Box
//         sx={{
//           position: "relative",
//           aspectRatio: "16/9",
//           width: "100%",
//           borderRadius: 2,
//           overflow: "hidden",
//           boxShadow: 3,
//           bgcolor: "#000",
//         }}
//       >
//         <div
//           ref={(el) => {
//             containerRef.current = el;
//           }}
//           style={{ width: "100%", height: "100%" }}
//         />
//       </Box>

//       <Box mt={2} textAlign="center">
//         <Typography variant="subtitle1" gutterBottom>
//           You have watched: <strong>{formatTime(playTime)}</strong>
//         </Typography>
//         <Stack direction="row" spacing={2} justifyContent="center">
//           <Button
//             onClick={play}
//             variant="contained"
//             disabled={!ready || isPlaying}
//             sx={{ minWidth: 100 }}
//           >
//             ▶️ Play
//           </Button>
//           <Button
//             onClick={pause}
//             variant="outlined"
//             disabled={!ready || !isPlaying}
//             sx={{ minWidth: 100 }}
//           >
//             ⏸️ Pause
//           </Button>
//           <Button
//             onClick={restart}
//             variant="text"
//             disabled={!ready}
//             sx={{ minWidth: 100 }}
//           >
//             🔁 Restart
//           </Button>
//         </Stack>
//         {!ready && (
//           <Typography variant="caption" color="text.secondary" mt={1}>
//             Initializing player...
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// // --- Like Button ---
// interface LikeButtonProps {
//   likes: number;
//   isInitiallyLiked?: boolean;
//   onToggle: (newLiked: boolean) => void;
// }
// const LikeButton: React.FC<LikeButtonProps> = ({
//   likes,
//   isInitiallyLiked = false,
//   onToggle,
// }) => {
//   const [count, setCount] = useState(likes);
//   const [isLiked, setIsLiked] = useState(isInitiallyLiked);
//   const togglingRef = useRef(false);

//   const toggleLike = async () => {
//     if (togglingRef.current) return;
//     togglingRef.current = true;
//     const nextLiked = !isLiked;
//     setIsLiked(nextLiked);
//     setCount((c) => (nextLiked ? c + 1 : Math.max(0, c - 1)));
//     try {
//       await onToggle(nextLiked);
//     } catch (e) {
//       setIsLiked(isLiked);
//       setCount((c) => (isLiked ? c + 1 : Math.max(0, c - 1)));
//     } finally {
//       togglingRef.current = false;
//     }
//   };

//   return (
//     <Stack direction="row" alignItems="center" spacing={2} mt={3}>
//       <IconButton onClick={toggleLike} color="primary" aria-label="like">
//         {isLiked ? <ThumbUpIcon /> : <ThumbUpOutlinedIcon />}
//       </IconButton>
//       <Typography variant="h6">{count.toLocaleString()} likes</Typography>
//     </Stack>
//   );
// };

// // --- Comment Avatar ---
// const CommentAvatar: React.FC<{ first_name?: string; user_id: number }> = ({
//   first_name,
//   user_id,
// }) => {
//   const bg = useMemo(() => {
//     const hue = Math.floor(Math.random() * 360);
//     return `hsl(${hue}, 60%, 70%)`;
//   }, []);

//   return (
//     <Avatar sx={{ bgcolor: bg, color: "#000" }}>
//       {first_name ? first_name[0].toUpperCase() : "G"}
//     </Avatar>
//   );
// };

// // --- Comment Form ---
// const CommentForm: React.FC<{ onSubmit: (c: Comment) => void }> = ({
//   onSubmit,
// }) => {
//   const [text, setText] = useState("");
//   const customerData = useAppSelector(
//     (state) => state.customer.personalDetails
//   );
//   const usermaster_id = sessionStorage.getItem("user_id");

//   const handleSubmit = (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!text.trim()) return;
//     onSubmit({
//       user_id: Number(sessionStorage.getItem("user_id")) || 0,
//       first_name: customerData?.firstname ?? "GuestUser",
//       vid_comment: text.trim(),
//     });
//     setText("");
//   };

//   return (
//     <Box component="form" onSubmit={handleSubmit} mt={3}>
//       <Stack direction="row" spacing={2}>
//         <CommentAvatar
//           first_name={customerData?.firstname}
//           user_id={Number(usermaster_id)}
//         />
//         <TextField
//           fullWidth
//           value={text}
//           onChange={(e) => setText(e.target.value)}
//           label="Add a comment"
//           multiline
//           rows={2}
//         />
//       </Stack>
//       <Box mt={2} textAlign="right">
//         <Button type="submit" variant="contained" disabled={!text.trim()}>
//           Comment
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// // --- Comment List ---
// const CommentList: React.FC<{ comments: Comment[] }> = ({ comments }) => (
//   <Box mt={3}>
//     {comments.map((c, i) => (
//       <Box key={i} mb={2}>
//         <Stack direction="row" spacing={2}>
//           <CommentAvatar first_name={c.first_name} user_id={c.user_id} />
//           <Box>
//             <Typography fontWeight="bold">
//               {c.first_name || "GuestUser"}
//             </Typography>
//             <Typography>{c.vid_comment}</Typography>
//             {c.updated_on && (
//               <Typography variant="caption" color="text.secondary">
//                 {new Date(c.updated_on).toLocaleString()}
//               </Typography>
//             )}
//           </Box>
//         </Stack>
//         {i !== comments.length - 1 && <Divider sx={{ my: 2 }} />}
//       </Box>
//     ))}
//   </Box>
// );

// // --- Comments Section ---
// interface CommentsSectionProps {
//   comments: Comment[];
//   onAddComment: (c: Comment) => void;
// }
// const CommentsSection: React.FC<CommentsSectionProps> = ({
//   comments,
//   onAddComment,
// }) => {
//   const COMMENT_ITEM_HEIGHT = 72;
//   const VISIBLE_COUNT = 5;

//   return (
//     <Paper elevation={3} sx={{ p: 3 }}>
//       <Typography variant="h6" mb={2}>
//         {comments.length} Comments
//       </Typography>
//       <CommentForm onSubmit={onAddComment} />
//       <Box
//         sx={{
//           maxHeight: COMMENT_ITEM_HEIGHT * VISIBLE_COUNT,
//           overflowY: "auto",
//           position: "relative",
//           marginTop: 1,
//         }}
//       >
//         <CommentList comments={comments} />
//       </Box>
//     </Paper>
//   );
// };

// // --- Main App ---
// const VideoApp: React.FC = () => {
//   const linkToDisplay = useAppSelector(
//     (state) => state.searchReducer.linkToDisplay
//   );
//   const customerDetails = useAppSelector(
//     (state) => state.customer.customerDetails
//   );

//   const [searchParams] = useSearchParams();
//   const location = useLocation();
//   const { title, article_id } = location.state as {
//     article_id: string;
//     title: string;
//   };

//   const articleId = searchParams.get("articleId") ?? article_id;
//   const customer_id = sessionStorage.getItem("informaticscustomer_id");
//   const usermaster_id = sessionStorage.getItem("user_id");
//   const consortia_id = customerDetails?.consortiamaster_id ?? null;

//   const [comments, setComments] = useState<Comment[]>([]);
//   const [likeCount, setLikeCount] = useState<number>(0);
//   const [isLiked, setIsLiked] = useState<boolean>(false);

//   const buttonLink = useMemo(() => {
//     if (!articleId || !Array.isArray(linkToDisplay)) return "";
//     const found = linkToDisplay.find((obj) => obj?.article_id === articleId);
//     return found?.links?.[0] || "";
//   }, [articleId, linkToDisplay]);

//   // still using fallback Vimeo URL if none found
//   const videoUrlToUse = buttonLink || "https://vimeo.com/759560753";

//   const normalizeComments = (raw: any[]): Comment[] =>
//     raw.map((c) => ({
//       comment_id: c.comment_id,
//       user_id: Number(c.user_id) || 0,
//       first_name: c.first_name || "GuestUser",
//       vid_comment: c.vid_comment || "",
//       updated_on: c.updated_on,
//     }));

//   useEffect(() => {
//     if (!articleId) return;
//     fetchLikeInfo();
//     fetchInitialComments();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [articleId, customer_id, usermaster_id, consortia_id]);

//   async function postLikeUsage(liked: boolean) {
//     if (!articleId) return;
//     const apiFormData = {
//       data: [
//         {
//           customer_id: customer_id,
//           usermaster_id: usermaster_id,
//           consortia_id: consortia_id,
//           article_id: articleId,
//           is_liked: liked,
//         },
//       ],
//     };
//     const formData = new FormData();
//     formData.append("detailed_json", JSON.stringify(apiFormData));
//     try {
//       await axios.post(
//         api.baseApi + `/api/insert_video_likes_usage/insert_video_likes_usage`,
//         formData
//       );
//     } catch (err) {
//       console.log("postLikeUsage error:", err);
//       throw err;
//     }
//   }

//   async function fetchLikeInfo() {
//     if (!articleId) return;
//     try {
//       const response = await axios.get(
//         api.baseApi +
//           `/api/get_article_like_by_id/get_article_like_by_id?article_id=${articleId}`
//       );
//       const data = response.data?.data?.[0];
//       if (data) {
//         setLikeCount(Number(data.liked_count ?? likeCount));
//         if (typeof data.is_liked === "boolean") setIsLiked(data.is_liked);
//       }
//     } catch (err) {
//       console.log("fetchLikeInfo error:", err);
//     }
//   }

//   async function fetchInitialComments() {
//     if (!articleId) return;
//     try {
//       const response = await axios.get(
//         api.baseApi +
//           `/api/get_article_comments_by_id/get_article_comments_by_id?article_id=${articleId}`
//       );
//       const fetched = response.data?.data?.[0];
//       if (Array.isArray(fetched) && fetched.length > 0) {
//         setComments(normalizeComments(fetched));
//       } else {
//         setComments([]);
//       }
//     } catch (err) {
//       console.log("fetchInitialComments error:", err);
//     }
//   }

//   async function postCommentUsage(comment: Comment) {
//     if (!articleId) return;
//     const apiFormData = {
//       data: [
//         {
//           customer_id: customer_id,
//           consortia_id: consortia_id,
//           usermaster_id: usermaster_id,
//           article_id: articleId,
//           status: true,
//           comments: comment.vid_comment ?? "",
//           user_id: comment.user_id,
//         },
//       ],
//     };
//     const formData = new FormData();
//     formData.append("detailed_json", JSON.stringify(apiFormData));
//     try {
//       await axios.post(
//         api.baseApi +
//           `/api/insert_video_coment_usage/insert_video_coment_usage?`,
//         formData
//       );
//     } catch (err) {
//       console.log("postCommentUsage error:", err);
//     }
//   }

//   const handleAddComment = async (newComment: Comment) => {
//     setComments((prev) => [newComment, ...prev]);
//     try {
//       await postCommentUsage(newComment);
//     } catch (e) {
//       console.log("handleAddComment error:", e);
//     }
//   };

//   const handleLikeToggle = async (nextLiked: boolean) => {
//     await postLikeUsage(nextLiked);
//     setIsLiked(nextLiked);
//     setLikeCount((prev) => (nextLiked ? prev + 1 : Math.max(0, prev - 1)));
//   };

//   const videoData = {
//     title: "Video Title Placeholder",
//     description: "Video description goes here.",
//   };

//   return (
//     <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", py: 5 }}>
//       <Container maxWidth="lg">
//         <Stack spacing={4} direction={{ xs: "column", lg: "row" }}>
//           <Box flex={2}>
//             <VimeoPlayer />
//             <Typography variant="h4" mt={4}>
//               {title || videoData.title}
//             </Typography>
//             <Typography mt={1} whiteSpace="pre-line">
//               {videoData.description}
//             </Typography>
//             <LikeButton
//               likes={likeCount}
//               isInitiallyLiked={isLiked}
//               onToggle={handleLikeToggle}
//             />
//           </Box>

//           <Box flex={1}>
//             <CommentsSection
//               comments={comments ?? []}
//               onAddComment={handleAddComment}
//             />
//           </Box>
//         </Stack>
//       </Container>
//     </Box>
//   );
// };

// export default VideoApp;

// ========================================================================

import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Avatar,
  TextField,
  Paper,
  IconButton,
  Stack,
  Divider,
} from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import { useLocation, useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import axios from "axios";
import api from "../../api/endpoints";

// --- Types ---
type Comment = {
  comment_id?: number;
  user_id: number;
  first_name?: string;
  vid_comment?: string;
  updated_on?: string;
};

// --- Vimeo SDK loader (no external package required) ---
declare global {
  interface Window {
    Vimeo: any;
  }
}
const loadVimeoSDK = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if ((window as any).Vimeo && (window as any).Vimeo.Player) {
      return resolve();
    }
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    script.async = true;
    script.onload = () => {
      if ((window as any).Vimeo && (window as any).Vimeo.Player) {
        resolve();
      } else {
        reject(new Error("Vimeo SDK loaded but Player not available"));
      }
    };
    script.onerror = () => reject(new Error("Failed to load Vimeo SDK"));
    document.body.appendChild(script);
  });
};

// --- VimeoPlayer with hardcoded full URL and full-fit video + fullscreen ---
const VimeoPlayer: React.FC = () => {
  const HARDCODED_VIMEO_URL = "https://vimeo.com/759560753"; // replace with desired Vimeo URL
  const [playTime, setPlayTime] = useState<number>(0);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [ready, setReady] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const playerRef = useRef<any>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setError(null);
    loadVimeoSDK()
      .then(() => {
        if (!containerRef.current) return;
        // @ts-ignore
        const player = new window.Vimeo.Player(containerRef.current, {
          url: HARDCODED_VIMEO_URL,
          //   autopause: true,
          autoplay: true,
        });
        playerRef.current = player;

        player
          .ready()
          .then(async () => {
            setReady(true);
            // ensure iframe fills fully
            let iframe: HTMLIFrameElement | null = null;
            try {
              iframe = await player.getIframe();
            } catch {
              iframe = containerRef.current?.querySelector(
                "iframe"
              ) as HTMLIFrameElement;
            }
            if (iframe) {
              iframe.style.position = "absolute";
              iframe.style.top = "0";
              iframe.style.left = "0";
              iframe.style.width = "100%";
              iframe.style.height = "100%";
              iframe.style.objectFit = "contain"; // change to "cover" to fill with cropping
            }
          })
          .catch((e: any) => {
            console.error("Vimeo ready error", e);
            setError("Failed to initialize Vimeo player.");
          });

        player.on("timeupdate", (data: { seconds: number }) => {
          setPlayTime(Math.floor(data.seconds));
        });
        player.on("play", () => setIsPlaying(true));
        player.on("pause", () => setIsPlaying(false));
        player.on("ended", () => setIsPlaying(false));
      })
      .catch((e) => {
        console.error("SDK load failed", e);
        setError("Failed to load Vimeo SDK.");
      });

    return () => {
      if (playerRef.current) {
        playerRef.current.unload?.().catch(() => {});
        playerRef.current = null;
      }
    };
  }, [HARDCODED_VIMEO_URL]);

  const play = () => playerRef.current?.play?.();
  const pause = () => playerRef.current?.pause?.();
  const restart = async () => {
    if (!playerRef.current) return;
    try {
      await playerRef.current.setCurrentTime(0);
      await playerRef.current.play();
    } catch (e) {
      console.error("Restart error:", e);
      setError("Unable to restart video.");
    }
  };

  const handleSamplePPT = () => {
    try {
      const url = "https://jgatenext.com/cdn/NCG-sample-support.pptx"; // replace with actual URL
      const newWin = window.open(url, "_blank", "noopener,noreferrer");
      if (!newWin) throw new Error("Popup blocked by browser");
    } catch (e) {
      console.error("Open PPT error:", e);
      //   setError("Unable to open sample PPT.");
    }
  };

  const formatTime = (s: number) => {
    if (isNaN(s) || s < 0) return "00:00";
    return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(
      s % 60
    ).padStart(2, "0")}`;
  };

  const enterFullscreen = () => {
    if (wrapperRef.current) {
      if (wrapperRef.current.requestFullscreen) {
        wrapperRef.current.requestFullscreen();
      } else if ((wrapperRef.current as any).webkitRequestFullscreen) {
        (wrapperRef.current as any).webkitRequestFullscreen();
      }
    }
  };

  if (error) {
    return (
      <Box>
        <Box
          sx={{
            aspectRatio: "16/9",
            width: "100%",
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 3,
            bgcolor: "#000",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography color="white">
            {error} <br />
            <code>{HARDCODED_VIMEO_URL}</code>
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box ref={wrapperRef} sx={{ width: "100%" }}>
      {/* Responsive container forcing 16:9, but scaling to fit parent */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          pt: "56.25%", // 16:9 ratio
          borderRadius: 2,
          overflow: "hidden",
          boxShadow: 3,
          bgcolor: "#000",
        }}
      >
        <div
          ref={(el) => {
            containerRef.current = el;
          }}
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
          }}
        />
      </Box>

      <Box mt={2} textAlign="center">
        <Typography variant="subtitle1" gutterBottom>
          You have watched: <strong>{formatTime(playTime)}</strong>
        </Typography>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          flexWrap="wrap"
        >
          <Button
            onClick={play}
            variant="contained"
            disabled={!ready || isPlaying}
            sx={{ minWidth: 100 }}
          >
            ▶️ Play
          </Button>
          <Button
            onClick={pause}
            variant="outlined"
            disabled={!ready || !isPlaying}
            sx={{ minWidth: 100 }}
          >
            ⏸️ Pause
          </Button>
          {/* <Button
            onClick={restart}
            variant="text"
            disabled={!ready}
            sx={{ minWidth: 100 }}
          >
            🔁 Restart
          </Button>
          <Button
            onClick={enterFullscreen}
            variant="outlined"
            sx={{ minWidth: 100 }}
          >
            ⛶ Fullscreen
          </Button> */}

          <Button
            onClick={handleSamplePPT}
            variant="outlined"
            // disabled={!ready}
            sx={{ minWidth: 100 }}
          >
            Sample PPT
          </Button>
        </Stack>
        {!ready && (
          <Typography variant="caption" color="text.secondary" mt={1}>
            Initializing player...
          </Typography>
        )}
      </Box>
    </Box>
  );
};

// --- Like Button ---
interface LikeButtonProps {
  likes: number;
  isInitiallyLiked?: boolean;
  onToggle: (newLiked: boolean) => void;
}
const LikeButton: React.FC<LikeButtonProps> = ({
  likes,
  isInitiallyLiked = false,
  onToggle,
}) => {
  const [count, setCount] = useState(likes);
  const [isLiked, setIsLiked] = useState(isInitiallyLiked);
  const togglingRef = useRef(false);

  const toggleLike = async () => {
    if (togglingRef.current) return;
    togglingRef.current = true;
    const nextLiked = !isLiked;
    setIsLiked(nextLiked);
    setCount((c) => (nextLiked ? c + 1 : Math.max(0, c - 1)));
    try {
      await onToggle(nextLiked);
    } catch (e) {
      setIsLiked(isLiked);
      setCount((c) => (isLiked ? c + 1 : Math.max(0, c - 1)));
    } finally {
      togglingRef.current = false;
    }
  };

  return (
    <Stack direction="row" alignItems="center" spacing={2} mt={3}>
      <IconButton onClick={toggleLike} color="primary" aria-label="like">
        {isLiked ? <ThumbUpIcon /> : <ThumbUpOutlinedIcon />}
      </IconButton>
      <Typography variant="h6">{count.toLocaleString()} likes</Typography>
    </Stack>
  );
};

// --- Comment Avatar ---
const CommentAvatar: React.FC<{ first_name?: string; user_id: number }> = ({
  first_name,
  user_id,
}) => {
  const bg = useMemo(() => {
    const hue = Math.floor(Math.random() * 360);
    return `hsl(${hue}, 60%, 70%)`;
  }, []);

  return (
    <Avatar sx={{ bgcolor: bg, color: "#000" }}>
      {first_name ? first_name[0].toUpperCase() : "G"}
    </Avatar>
  );
};

// --- Comment Form ---
const CommentForm: React.FC<{ onSubmit: (c: Comment) => void }> = ({
  onSubmit,
}) => {
  const [text, setText] = useState("");
  const customerData = useAppSelector(
    (state) => state.customer.personalDetails
  );
  const usermaster_id = sessionStorage.getItem("user_id");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim()) return;
    onSubmit({
      user_id: Number(sessionStorage.getItem("user_id")) || 0,
      first_name: customerData?.firstname ?? "GuestUser",
      vid_comment: text.trim(),
    });
    setText("");
  };

  return (
    <Box component="form" onSubmit={handleSubmit} mt={3}>
      <Stack direction="row" spacing={2}>
        <CommentAvatar
          first_name={customerData?.firstname}
          user_id={Number(usermaster_id)}
        />
        <TextField
          fullWidth
          value={text}
          onChange={(e) => setText(e.target.value)}
          label="Add a comment"
          multiline
          rows={2}
        />
      </Stack>
      <Box mt={2} textAlign="right">
        <Button type="submit" variant="contained" disabled={!text.trim()}>
          Comment
        </Button>
      </Box>
    </Box>
  );
};

// --- Comment List ---
const CommentList: React.FC<{ comments: Comment[] }> = ({ comments }) => (
  <Box mt={3}>
    {comments.map((c, i) => (
      <Box key={i} mb={2}>
        <Stack direction="row" spacing={2}>
          <CommentAvatar first_name={c.first_name} user_id={c.user_id} />
          <Box>
            <Typography fontWeight="bold">
              {c.first_name || "GuestUser"}
            </Typography>
            <Typography>{c.vid_comment}</Typography>
            {c.updated_on && (
              <Typography variant="caption" color="text.secondary">
                {new Date(c.updated_on).toLocaleString()}
              </Typography>
            )}
          </Box>
        </Stack>
        {i !== comments.length - 1 && <Divider sx={{ my: 2 }} />}
      </Box>
    ))}
  </Box>
);

// --- Comments Section ---
interface CommentsSectionProps {
  comments: Comment[];
  onAddComment: (c: Comment) => void;
}
const CommentsSection: React.FC<CommentsSectionProps> = ({
  comments,
  onAddComment,
}) => {
  const COMMENT_ITEM_HEIGHT = 72;
  const VISIBLE_COUNT = 5;

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h6" mb={2}>
        {comments.length} Comments
      </Typography>
      <CommentForm onSubmit={onAddComment} />
      <Box
        sx={{
          maxHeight: COMMENT_ITEM_HEIGHT * VISIBLE_COUNT,
          overflowY: "auto",
          position: "relative",
          marginTop: 1,
        }}
      >
        <CommentList comments={comments} />
      </Box>
    </Paper>
  );
};

// --- Main App ---
const VideoApp: React.FC = () => {
  const linkToDisplay = useAppSelector(
    (state) => state.searchReducer.linkToDisplay
  );
  const customerDetails = useAppSelector(
    (state) => state.customer.customerDetails
  );

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { title, article_id } = location.state as {
    article_id: string;
    title: string;
  };

  const articleId = searchParams.get("articleId") ?? article_id;
  const customer_id = sessionStorage.getItem("informaticscustomer_id");
  const usermaster_id = sessionStorage.getItem("user_id");
  const consortia_id = customerDetails?.consortiamaster_id ?? null;

  const [comments, setComments] = useState<Comment[]>([]);
  const [likeCount, setLikeCount] = useState<number>(0);
  const [isLiked, setIsLiked] = useState<boolean>(false);

  const buttonLink = useMemo(() => {
    if (!articleId || !Array.isArray(linkToDisplay)) return "";
    const found = linkToDisplay.find((obj) => obj?.article_id === articleId);
    return found?.links?.[0] || "";
  }, [articleId, linkToDisplay]);

  const videoUrlToUse = buttonLink || "https://vimeo.com/759560753"; // fallback

  const normalizeComments = (raw: any[]): Comment[] =>
    raw.map((c) => ({
      comment_id: c.comment_id,
      user_id: Number(c.user_id) || 0,
      first_name: c.first_name || "GuestUser",
      vid_comment: c.vid_comment || "",
      updated_on: c.updated_on,
    }));

  useEffect(() => {
    if (!articleId) return;
    fetchLikeInfo();
    fetchInitialComments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleId, customer_id, usermaster_id, consortia_id]);

  async function postLikeUsage(liked: boolean) {
    if (!articleId) return;
    const apiFormData = {
      data: [
        {
          customer_id: customer_id,
          usermaster_id: usermaster_id,
          consortia_id: consortia_id,
          article_id: articleId,
          is_liked: liked,
        },
      ],
    };
    const formData = new FormData();
    formData.append("detailed_json", JSON.stringify(apiFormData));
    try {
      await axios.post(
        api.baseApi + `/api/insert_video_likes_usage/insert_video_likes_usage`,
        formData
      );
    } catch (err) {
      console.log("postLikeUsage error:", err);
      throw err;
    }
  }

  async function fetchLikeInfo() {
    if (!articleId) return;
    try {
      const response = await axios.get(
        api.baseApi +
          `/api/get_article_like_by_id/get_article_like_by_id?article_id=${articleId}`
      );
      const data = response.data?.data?.[0];
      if (data) {
        setLikeCount(Number(data.liked_count ?? likeCount));
        if (typeof data.is_liked === "boolean") setIsLiked(data.is_liked);
      }
    } catch (err) {
      console.log("fetchLikeInfo error:", err);
    }
  }

  async function fetchInitialComments() {
    if (!articleId) return;
    try {
      const response = await axios.get(
        api.baseApi +
          `/api/get_article_comments_by_id/get_article_comments_by_id?article_id=${articleId}`
      );
      const fetched = response.data?.data?.[0];
      if (Array.isArray(fetched) && fetched.length > 0) {
        setComments(normalizeComments(fetched));
      } else {
        setComments([]);
      }
    } catch (err) {
      console.log("fetchInitialComments error:", err);
    }
  }

  async function postCommentUsage(comment: Comment) {
    if (!articleId) return;
    const apiFormData = {
      data: [
        {
          customer_id: customer_id,
          consortia_id: consortia_id,
          usermaster_id: usermaster_id,
          article_id: articleId,
          status: true,
          comments: comment.vid_comment ?? "",
          user_id: comment.user_id,
        },
      ],
    };
    const formData = new FormData();
    formData.append("detailed_json", JSON.stringify(apiFormData));
    try {
      await axios.post(
        api.baseApi +
          `/api/insert_video_coment_usage/insert_video_coment_usage?`,
        formData
      );
    } catch (err) {
      console.log("postCommentUsage error:", err);
    }
  }

  const handleAddComment = async (newComment: Comment) => {
    setComments((prev) => [newComment, ...prev]);
    try {
      await postCommentUsage(newComment);
    } catch (e) {
      console.log("handleAddComment error:", e);
    }
  };

  const handleLikeToggle = async (nextLiked: boolean) => {
    await postLikeUsage(nextLiked);
    setIsLiked(nextLiked);
    setLikeCount((prev) => (nextLiked ? prev + 1 : Math.max(0, prev - 1)));
  };

  //   const videoData = {
  //     title: "Video Title Placeholder",
  //     description: "Video description goes here.",
  //   };

  const videoData = {
    url: "https://youtu.be/yiFxruo4Stc", // can also be "https://www.youtube.com/watch?v=yiFxruo4Stc"
    title: "Adult Hematolymphoid - Case 2 - JIPMER - Low Grade B Cell Lymphoma",
    description: `Speaker: Dr. Prasanth\nOrganization: JIPMER\n\n55 year old female with renal involvement low-grade B Cell lymphoma.`,
    likes: 56000,
    initialComments: [
      {
        user: "MedicalStudent",
        text: "Very informative case study. Thank you for sharing!",
        avatar: "https://placehold.co/40x40/f87171/ffffff?text=M",
      },
      {
        user: "PathologyPro",
        text: "Excellent presentation by Dr. Prasanth. The renal involvement aspect is particularly interesting.",
        avatar: "https://placehold.co/40x40/34d399/ffffff?text=P",
      },
    ],
  };

  return (
    <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", py: 5 }}>
      <Container maxWidth="lg">
        <Stack spacing={4} direction={{ xs: "column", lg: "row" }}>
          <Box flex={2}>
            <VimeoPlayer />
            <Typography variant="h4" mt={4}>
              {title || videoData.title}
            </Typography>
            <Typography mt={1} whiteSpace="pre-line">
              {videoData.description}
            </Typography>
            <LikeButton
              likes={likeCount}
              isInitiallyLiked={isLiked}
              onToggle={handleLikeToggle}
            />
          </Box>

          <Box flex={1}>
            <CommentsSection
              comments={comments ?? []}
              onAddComment={handleAddComment}
            />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default VideoApp;
